<template>
    <span class="text-wrap mr-3 mb-3">
        <a class="badge badge-warning" v-bind:href="computedHref">{{name}}</a>
    </span>
</template>


<script>
export default {
    name : 'CategoryItem',
    props: {
        //categoryid: Number,
        name: String,
        onlyShow:{
            type: Boolean,
            default:false
        }
    },

    computed: {
        computedHref : function(){
            if(this.onlyShow){
                return '#'
            }else{
                return this.name == '全部' ? '/' : '/blog/category?name='+this.name
            }
        }
    }
}

</script>

<style scoped>
    .blog-item{
        padding-bottom: 20px;
    }
</style>